/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCampaignMetadataRequest} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'
import {GetCampaignMetadataResponse} from '@cash-web/protos/squareup/cash/cashplato/api/v1/cash_plato_service.pb'


export const getCampaignMetadata = (request: GetCampaignMetadataRequest, options?: CashRequestOptions) => post<GetCampaignMetadataRequest, GetCampaignMetadataResponse>("/2.0/cash/get-campaign-metadata", request, {...options, rejectOnError: true })